import { HttpService } from "../../../common/api/httpService";
import {
    ProfitAdjustmentListRequest,
    ProfitAdjustmentListResult,
    UpdateProfitAdjustmentRequest,
    CreateProfitAdjustmentRequest,
} from "../../../models/profitAdjustments";
import { RequestResultValue, RequestResult } from "../../../common/api/requestResult";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export class ProfitAdjustmentsApi {
    private static http = HttpService.getInstance();

    static async list(req: ProfitAdjustmentListRequest): Promise<RequestResultValue<ProfitAdjustmentListResult>> {
        const payload: any = {
            page: req.page,
            count: req.count,
        };

        if (req.userId && req.userId.trim().length > 0) {
            try {
                // Используем BigInt, чтобы не терять точность больших идентификаторов.
                payload.userId = BigInt(req.userId);
            } catch {
                // Если не удалось распарсить, отправляем как есть — бэкенд вернёт ошибку/пустой результат.
                payload.userId = req.userId;
            }
        }

        const response = await this.http.requestPostAsync("admin/profitAdjustments/list", JSONbig.stringify(payload));
        const text = await response.text();
        const body = JSONbigNative.parse(text);

        if (response.status >= 200 && response.status < 300) {
            return new RequestResultValue<ProfitAdjustmentListResult>(true, body as ProfitAdjustmentListResult);
        }

        return new RequestResultValue<ProfitAdjustmentListResult>(false);
    }

    static async update(req: UpdateProfitAdjustmentRequest): Promise<RequestResult> {
        const payload: any = {
            id: req.id,
        };

        if (req.comment !== undefined) payload.comment = req.comment;
        if (req.amount !== undefined && req.amount !== null) payload.amount = req.amount;
        if (req.date !== undefined) payload.date = req.date;
        if (req.userId !== undefined && req.userId !== null) {
            try {
                payload.userId = BigInt(req.userId);
            } catch {
                payload.userId = req.userId;
            }
        }

        const response = await this.http.requestPutAsync("admin/ProfitAdjustments", JSONbig.stringify(payload));

        if (response.status === 204) {
            return new RequestResult(true);
        }

        const text = await response.text();
        let body: any = undefined;
        try {
            body = text ? JSONbigNative.parse(text) : undefined;
        } catch {
            body = text;
        }

        if (response.status >= 200 && response.status < 300) {
            return new RequestResult(true, body);
        }

        return new RequestResult(false, body);
    }

    static async create(req: CreateProfitAdjustmentRequest): Promise<RequestResult> {
        const payload: any = {};

        payload.amount = req.amount;
        if (req.comment !== undefined) payload.comment = req.comment;

        if (req.userId !== undefined && req.userId !== null) {
            try {
                payload.userId = BigInt(req.userId);
            } catch {
                payload.userId = req.userId;
            }
        }

        if (req.date !== undefined) {
            payload.date = req.date;
        }

        const response = await this.http.requestPostAsync("admin/ProfitAdjustments", JSONbig.stringify(payload));

        if (response.status === 204) {
            return new RequestResult(true);
        }

        const text = await response.text();
        let body: any = undefined;
        try {
            body = text ? JSONbigNative.parse(text) : undefined;
        } catch {
            body = text;
        }

        if (response.status >= 200 && response.status < 300) {
            return new RequestResult(true, body);
        }

        return new RequestResult(false, body);
    }
}

